import { render, staticRenderFns } from "./PDFInsert.vue?vue&type=template&id=2b2ac508&"
import script from "./PDFInsert.vue?vue&type=script&lang=js&"
export * from "./PDFInsert.vue?vue&type=script&lang=js&"
import style0 from "./PDFInsert.vue?vue&type=style&index=0&id=2b2ac508&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports